import Home from "./pages/Home";
import Upload from "./pages/Upload";
import Pricing from "./pages/Pricing";
import Tools from "./pages/Tools";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Checkouts from "./pages/Checkouts";
import DashBoard from "./pages/DashBoard";
import History from "./pages/History";
import { BrowserRouter, HashRouter, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import "./App.css";
import app from "./FirebaseConfig";
function App() {
  return (
    <HashRouter basename="/">
      <UserAuthContextProvider>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>

          <Route path="/upload" exact>
            <Upload />
          </Route>

          <Route path="/tools" exact>
            <Tools />
          </Route>

          <Route path="/login" exact>
            <Login />
          </Route>

          <Route path="/checkouts" exact>
            <Checkouts />
          </Route>

          <Route path="/pricing" exact>
            <Pricing />
          </Route>
         
          <ProtectedRoute>
            <Route path="/dashboard">
              <DashBoard />
            </Route>

            <Route path="/history" exact>
            <History />
          </Route>
          </ProtectedRoute>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </UserAuthContextProvider>
    </HashRouter>
  );
}

export default App;
